/** Which side of its icon an `InfoTooltip` popup opens on. */
export const TooltipSide = {
  TOP: "top",
  BOTTOM: "bottom",
} as const;
export type TooltipSide = (typeof TooltipSide)[keyof typeof TooltipSide];
